export const RECENT_INVOICES_GRID =
  "hidden items-center gap-x-xl @3xl:grid @3xl:grid-cols-[auto_minmax(150px,170fr)_minmax(230px,248fr)_minmax(100px,100fr)_minmax(72px,90fr)_auto] @4xl:grid-cols-[auto_minmax(150px,170fr)_minmax(100px,380fr)_minmax(230px,248fr)_minmax(100px,100fr)_minmax(72px,90fr)_auto]";
